import { node, bool, string, oneOf } from "prop-types";
import React from "react";
import { twMerge } from "tailwind-merge";

import LoadingCircle from "../shared/Icons/LoadingCircle";

const VARIANT = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
};

const VARIANT_CLASSNAME = {
  [VARIANT.PRIMARY]:
    "border-transparent bg-primaryOrange text-white hover:text-primaryOrange hover:bg-white",
  [VARIANT.SECONDARY]:
    "border-primaryOrange bg-white text-primaryOrange hover:bg-primaryOrange hover:text-white disabled:border-disabledButtonFG",
};

const SIZE = {
  SMALL: "small",
  LARGE: "large",
};

const SIZE_CLASSNAME = {
  [SIZE.SMALL]: "px-4 py-2.5",
  [SIZE.LARGE]: "px-8 py-5 min-w-50",
};

export const Button = props => {
  const {
    children,
    className,
    isLoading = false,
    size = SIZE.LARGE,
    variant = VARIANT.PRIMARY,
    ...restProps
  } = props;

  return (
    <button
      className={twMerge(
        "flex justify-center items-center cursor-pointer gap-1 rounded-full",
        "transition duration-150 hover:scale-105 active:scale-95",
        "lowercase font-semibold relative overflow-hidden border-2",
        isLoading && "pointer-events-none",
        "disabled:pointer-events-none disabled:bg-disabledButtonBG disabled:text-disabledButtonFG",
        VARIANT_CLASSNAME[variant],
        SIZE_CLASSNAME[size],
        className
      )}
      {...restProps}
    >
      {isLoading && (
        <span className="absolute inset-0 bg-white/50 grid place-items-center p-2">
          <LoadingCircle className="size-full" />
        </span>
      )}
      {children}
    </button>
  );
};

export const LinkButton = props => {
  const {
    children,
    className,
    disabled = false,
    isLoading = false,
    size = SIZE.LARGE,
    variant = VARIANT.PRIMARY,
    ...restProps
  } = props;

  return (
    <a
      className={twMerge(
        "flex justify-center items-center cursor-pointer gap-1 rounded-full",
        "transition duration-150 hover:scale-105 active:scale-95",
        "lowercase font-semibold relative overflow-hidden border-2",
        isLoading && "pointer-events-none",
        disabled &&
          "pointer-events-none bg-disabledButtonBG text-disabledButtonFG",
        VARIANT_CLASSNAME[variant],
        SIZE_CLASSNAME[size],
        className
      )}
      {...restProps}
    >
      {isLoading && (
        <span className="absolute inset-0 bg-white/50 grid place-items-center p-2">
          <LoadingCircle className="size-full" />
        </span>
      )}
      {children}
    </a>
  );
};

Button.propTypes = {
  children: node.isRequired,
  className: string,
  isLoading: bool,
  size: oneOf(Object.values(SIZE)),
  variant: oneOf(Object.values(VARIANT)),
};

LinkButton.propTypes = {
  children: node.isRequired,
  className: string,
  disabled: bool,
  isLoading: bool,
  size: oneOf(Object.values(SIZE)),
  variant: oneOf(Object.values(VARIANT)),
};
